<template>
    <div class="lookup-container" style="display: flex;">
        <parliamentarian-lookup
        :value="typeof value ==='string' ? JSON.parse(value).individual : null"
        @input="emitIndividual($event)"
        ></parliamentarian-lookup>        
        <v-combobox                 
            label="Attendance" 
            :items="outcomes"
            :value="typeof value ==='string' ? JSON.parse(value).attendance : null"
            @input="emitAttendance($event)"
            solo flat 
            >
        </v-combobox>        
    </div>
</template>
<script>
import axios from 'axios'
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

import ParliamentarianLookup from './ParliamentarianLookup.vue';

export default {
    props: ['value'],
    data() {
        return ({            
            outcomes: ['Attended', 'Did not attend']
        })
    },
    components: {
        ParliamentarianLookup
    },
    methods: {
        emitIndividual($event) {
            this.$emit('input', JSON.stringify({...JSON.parse(this.value), individual: $event}));
            
        },
        emitAttendance($event) {
            this.$emit('input', JSON.stringify({...JSON.parse(this.value), attendance: $event}));
        }     
    }
}
</script>